import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import api from "@/lib/api";

export default function StreakBadge() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/streak").then((r) => setData(r.data)).catch(() => {});
    }, []);

    if (!data || data.current_streak < 1) return null;

    const label = `${data.current_streak} day${data.current_streak > 1 ? "s" : ""} with Pax`;
    return (
        <div
            className="inline-flex items-center gap-1.5 bg-terracotta/10 border border-terracotta/25 text-terracotta rounded-full px-3 py-1 font-body text-xs tracking-wide"
            data-testid="streak-badge"
            title={`longest streak: ${data.longest_streak}`}
        >
            <Flame className="w-3.5 h-3.5" />
            {label}
        </div>
    );
}
